import CustomSelect from "../plugins/custom-select.js";

new CustomSelect('.contact_select__wrapper', '.contact_select__title', '.contact_select__options')
